<template>
  <div class="d-flex">
    <div v-html="displayLabelTag" @click="$emit('click', $event)" />
    <slot name="after-label"></slot>
    <slot name="after-label2"></slot>
    <div class="setting-container ml-1" v-if="isAgent">
      <i
        title="Settings"
        @click="showSettingDialog()"
        class="settings-icon material-icons"
        :class="{ small: useSmallIcon }"
      >
        edit
      </i>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import { FORM_TYPE } from "../../constants/custom-define-type";

export default {
  name: "EditLabelSetting",
  props: {
    title: {
      type: String,
      default: "Edit Label",
    },
    modelKey: String,
    defaultValue: String,
    useSmallIcon: {
      type: Boolean,
      default: false,
    },
    onSubmitCallback: null,
    onSubmitCallbackData: {},
    tagName: {
      type: String,
      default: "label",
    },
    classList: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    additionalFields: Array,
  },
  data() {
    return {
      isShowInputDialog: false,
      originalData: {},
      listFields: [],
    };
  },
  computed: {
    ...mapGetters(["isAgent", "agencyID", "agencyPublic", "agency"]),
    displayLabel() {
      const tokens = this.modelKey.split(".");
      let container =
        tokens[0] === "advance_setting" ? this.agency : this.agencyPublic;
      return (
        this.tryGet(() => container[tokens[0]][tokens[1]]) || this.defaultValue
      );
    },
    displayLabelTag() {
      const disableToken = this.disabled ? `disabled="${this.disabled}"` : "";
      return `<${this.tagName} class="${this.classList}" ${disableToken}">${this.displayLabel}</${this.tagName}>`;
    },
  },
  methods: {
    async showSettingDialog() {
      const listKeys = [this.modelKey];
      if (this.additionalFields && this.additionalFields.length) {
        for (const field of this.additionalFields) {
          listKeys.push(field.modelKey);
        }
      }
      const res = await axios.get(
        `/agency-settings/${this.agencyID}/?fields=${listKeys.join(",")}`
      );
      let listFields = [
        {
          type: FORM_TYPE.TEXTBOX,
          model: this.modelKey,
        },
      ];
      const initialData = {
        [this.modelKey]: res.data[this.modelKey] || this.defaultValue,
      };
      if (this.additionalFields && this.additionalFields.length) {
        for (const field of this.additionalFields) {
          if (field.modelKey === this.modelKey) {
            // If the current setting is specified in the additionalFields, use the one in additional field
            listFields = listFields.filter(
              (field) => field.model !== this.modelKey
            );
          }
          listFields.push({
            type: FORM_TYPE.TEXTBOX,
            model: field.modelKey,
            label: field.label,
          });
          initialData[field.modelKey] =
            res.data[field.modelKey] || field.defaultValue;
        }
      }
      this.showInputDialog({
        title: this.title,
        listFields: listFields,
        data: initialData,
        onSubmitCallback: this.handleUpdateSetting,
      });
    },
    async handleUpdateSetting(info) {
      const res = await axios.patch(`/agency-settings/${this.agencyID}/`, info);
      if (res && res.data) {
        this.$toasted.show(`Updated label`);
        this.setAgency(res.data);
        if (this.onSubmitCallback) {
          this.showInputDialog(null);
          await this.onSubmitCallback(this.onSubmitCallbackData);
        }
        this.$emit("settingUpdated", info);
      }
    },
  },
};
</script>
<style scoped>
.setting-container {
  display: inline-block;
  display: flex;
  align-items: center;
}

.settings-icon {
  cursor: pointer;
  opacity: 0.8;
  color: var(--coredarkcolor);
}
.settings-icon {
  font-size: 14px;
}
.settings-icon.small {
  font-size: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/EditLabelSetting.vue